import { PaymentsActivity } from "components/PaymentsLanding/Tabs/PaymentsActivity/PaymentsActivity";
import { createFileRoute } from "@tanstack/react-router";
import { getPaymentsActivityDefaultSearch } from "utils/routeDefaults";
import { useHeaderDates } from "molecules/filters/rangePicker/datePickerContext";
import type { PaymentsActivityStatusFilterType } from "components/PaymentsLanding/Tabs/PaymentsActivity/PaymentsActivityBar/paymentsActivityStatusFilterHelpers";
import type { TransactionSource } from "api/responses";

export interface PaymentsActivitySearchParams {
    patientName: string;
    statuses: PaymentsActivityStatusFilterType[];
    sources: TransactionSource[];
}

export type PaymentsActivitySearchParamsPartial = Partial<PaymentsActivitySearchParams>;

export const Route = createFileRoute("/history/payments")({
    component: PaymentsActivityRoute,
    validateSearch: getPaymentsActivityDefaultSearch,
});

function PaymentsActivityRoute() {
    const { patientName, statuses, sources } = Route.useSearch() satisfies PaymentsActivitySearchParams;
    const [start, end] = useHeaderDates();

    return start && end ? (
        <PaymentsActivity
            active={true}
            startDateMs={start}
            endDateMs={end}
            patientName={patientName}
            statuses={statuses}
            sources={sources}
        />
    ) : null;
}
